import axios from 'axios';
import { BUSINESS_API_BASE_URL } from './endpoint';

export const fetchAvailability = async (businessId, workerId, serviceId, startDate, endDate) => {
  const params = {};
  
  if (startDate) {
    params.start_date = startDate;
  }
  if (endDate) {
    params.end_date = endDate;
  }
  if (serviceId) {
    params.service_id = serviceId;
  }

  console.log("Fetching availability with params:", workerId, serviceId, startDate, endDate);
  
  const response = await axios.get(`${BUSINESS_API_BASE_URL}/business/${businessId}/worker/${workerId}/availability`, {
      params,
      withCredentials: true,
      headers: {
          'Content-Type': 'application/json'
      }
  });
  return response.data;
}

export const fetchAllAvailability = async (businessId, serviceId, startDate, endDate) => {
  try {
    const params = {};
    
    if (startDate) {
      params.start_date = startDate;
    }
    if (endDate) {
      params.end_date = endDate;
    }
    if (serviceId) {
      params.service_id = serviceId;
    }

    console.log("Fetching all availability with params:", serviceId, startDate, endDate);
    
    const response = await axios.get(`${BUSINESS_API_BASE_URL}/business/${businessId}/availability`, {
        params,
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching all availability:", error);
    return [];
  }
}
